<template>
  <div>
    <div v-if="this.training._id" class="page-title mb-3 underline"><mdb-icon  icon="university" /> {{training.name}}</div>
    <mdb-row>
      <mdb-col md="2" class="v-list">
        <mdb-btn icon="list" class="m-0 mb-2 p-1 px-3" @click="onList">훈련 목록</mdb-btn>
        <vertical-list :titles="routes.titles" :active="current" @select-item="onSelectItem"/>
      </mdb-col>
      <mdb-col md="10">
        <router-view></router-view>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import {} from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import VerticalList from '../../../../components/common/VerticalList.vue'
export default {
  name: 'StaffOpenTrainingDetailPage',
  components: { VerticalList },
  props: [],
  data: () => ({
    TAG: 'StaffOpenTrainingDetailPage >>',
    routes: {
      titles: ['훈련개요', '교과편성 총괄표', '교과별계획', '사전필답평가', '수행평가', '필답평가', '태도평가', '포트폴리오'],
      comps: [
        'StaffOpenTrainingIntro', 'StaffOpenTrainingStructure', 'StaffOpenTrainingPlan',
        'StaffOpenTrainingPreTest', 'StaffOpenTrainingPefrom', 'StaffOpenTrainingWritingTest', 'StaffOpenTrainingAttitude', 'StaffOpenTrainingPortfolio']
    },
    current: 0
  }),
  computed: mapState('training', ['training']),
  methods: {
    async load () {
      const name = this.$route.name
      // console.log(this.routes.comps)
      this.current = this.routes.comps.findIndex(c => c === name)
    },
    onSelectItem (index) {
      this.current = index
      const name = this.routes.comps[index]
      this.$router.push({ name, query: this.$route.query })
    },
    onList () {
      this.$router.push({ name: 'StaffOpenTrainingPage' })
    }
  },
  watch: {
  },
  created () { this.load() }
}
</script>
